/* eslint-disable react/display-name */
import { useState, forwardRef, useContext, useEffect } from "react";
import {
	NexcalEmployeeLogo,
	PhcsLogo,
	QuestDiagonosticLogo,
	BrookshireLogo,
	CPLLogo,
	HealthSmartLogo,
	NexcalLogo,
	NexcalLogoPurple
} from "../../../../../assets";
import { AuthContext } from "../../../../../contexts";
import { maskSSN } from "../../../../../constants/maskSSN";
import CustomDataGrid from "../../../../shared/customDataGrid/CustomDataGrid";

import { Paper, Grid } from "@mui/material";
import QRCode from "react-qr-code";
import { getLocalIPV4 } from "../../../../../utils/commonFunctions/getLocalIP4";
import encryption from "../../../../../utils/commonFunctions/encryption";
import { MEMBER_ENV } from "../../../../../config/config";

import "./healthCardActual.css";

const HealthCardActual = () => {
	const [localIP, setLocalIP] = useState("");
	const [urlLink, setUrlLink] = useState("");
	const { member } = useContext(AuthContext);

	// console.log("Member Details", member);
	const _ssn = maskSSN(member?.SSN);
	// const { SSN, first_name, last_name, group_number } = member;
	// const _ssn = maskSSN(SSN);
	useEffect(() => {
		// eslint-disable-next-line arrow-parens
		getLocalIPV4().then((ip) => setLocalIP(ip));
	}, []);

	useEffect(() => {
		const { group_number, date_of_birth, SSN } = member;

		if (member && localIP) {
			const localRedirectionLink = `http:${localIP}:3002/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			const prodRedirectionLink = `www.nexcaliber.com/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			if (member && MEMBER_ENV === "LOCAL") setUrlLink(localRedirectionLink);
			if (member && (MEMBER_ENV === "PROD" || MEMBER_ENV === "DEV")) setUrlLink(prodRedirectionLink);
		}
	}, [member, localIP]);
	return (
		<div>
			<div className="employee-health-card-container">
				<div className="paper-form-container">
					<Paper className="theme-border-radius emp-paper-container" elevation={1}>
						<Grid container className="card-header-container">
							<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="group-logo">
								<img
									src={HealthSmartLogo}
									alt="Brookshire-logo"
									style={{ width: "8rem", height: "auto", marginTop: "1rem" }}
								/>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="health-card-content">
								<div className="employee-health-card-header">
									<span style={{ fontSize: "1rem" }}>Intercity Investment, Inc.</span>
								</div>
								<div className="employee-health-card-sub-header">
									<span style={{ marginTop: 4 }}>Administrated by Nexcaliber</span>
								</div>
								<div>
									<img
										src={NexcalLogoPurple}
										style={{
											width: "9rem",
											height: "auto",
											marginLeft: "4.8rem",
											marginTop: "0"
										}}
										alt=""
									/>
								</div>
							</Grid>
						</Grid>
						<div className="employee-health-border" />
						<Grid container className="employee-card-details-container">
							<div className="employee-details-description">
								<span>Group Benifits Plan Identification Card</span>
								<span>Health Plan Group #188</span>
							</div>
							<Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
								<div className="employee-details-container">
									<span>Employee ID Number:</span>
									<span style={{ marginLeft: "0.2rem" }}>XXX-XX-{_ssn}</span>
								</div>

								<div className="employee-details-container" style={{ marginTop: "0.1rem" }}>
									<span>Employee Name:</span>
									<span style={{ marginLeft: "0.2rem" }}>
										{member?.last_name.toUpperCase()}, {member?.first_name.toUpperCase()}
									</span>
								</div>
							</Grid>
							<Grid item xs={5} sm={5} md={5} lg={5} xl={5} style={{ marginTop: "-2rem" }}></Grid>
						</Grid>
						<div className="employee-health-border" />
						<Grid container className="employee-card-details-container">
							<div className="employee-details-description">
								<span>Prescription Benefits with Express Scripts - Rx GRoup #A2AE</span>
							</div>
						</Grid>
						<Grid container className="employee-card-details-container">
							<span style={{ fontWeight: "bolder", textDecoration: "underline", fontSize: "0.7rem" }}>
								Express Scripts Pharmacy:
							</span>
						</Grid>

						<div className="employee-details-container-express-scripts" style={{ marginTop: "0.1rem" }}>
							<div className="employee-details-container-express-scripts-label">
								<div>Brand Name (Multi-Source):</div>
								<div>Brand Name (Single-Source):</div>
								<div>Generic:</div>
							</div>
							<div
								className="employee-details-container-express-scripts-value"
								style={{ marginLeft: "1rem" }}
							>
								<div>$25.00 or 30% whichever is greater</div>
								<div>$40.00 or 30% whichever is greater</div>
								<div>$10.00 or 30% whichever is greater</div>
							</div>
							<span
								className="qr-code-container"
								style={{
									position: "relative",
									marginLeft: "1rem",
									marginTop: "-1.3rem"
									// backgroundColor: "red"
								}}
							>
								<QRCode
									size={256}
									style={{
										height: "4.5rem",
										maxWidth: "100%",
										width: "100%",
										marginBottom: "-0.25rem"
									}}
									// value={"www.nexcaliber.com"}
									value={urlLink}
									fgColor="#4e4e4e"
									bgColor="#ffffff"
								/>

								{/* Top-left corner border */}
								<div
									className="corner-border top-left"
									style={{
										position: "absolute",
										top: -5,
										left: -5,
										width: "20px",
										height: "20px",
										borderTop: "2px solid #9c27b0",
										borderLeft: "2px solid #9c27b0"
									}}
								></div>

								{/* Top-right corner border */}
								<div
									className="corner-border top-right"
									style={{
										position: "absolute",
										top: -5,
										right: -5,
										width: "20px",
										height: "20px",
										borderTop: "2px solid #9c27b0",
										borderRight: "2px solid #9c27b0"
									}}
								></div>

								{/* Bottom-left corner border */}
								<div
									className="corner-border bottom-left"
									style={{
										position: "absolute",
										bottom: -6,
										left: -5,
										width: "20px",
										height: "20px",
										borderBottom: "2px solid #9c27b0",
										borderLeft: "2px solid #9c27b0"
									}}
								></div>

								{/* Bottom-right corner border */}
								<div
									className="corner-border bottom-right"
									style={{
										position: "absolute",
										bottom: -6,
										right: -5,
										width: "20px",
										height: "20px",
										borderBottom: "2px solid #9c27b0",
										borderRight: "2px solid #9c27b0"
									}}
								></div>
							</span>
						</div>
						<div
							className="employee-details-container-helpline"
							style={{ marginTop: "0.2rem", marginLeft: "0" }}
						>
							<div className="employee-details-container-helpline-number">
								<div>
									<span>Pharmacy Help Desk:</span>
									<span>(800)235-4357</span>
								</div>
								<div>
									<span>Pharmacy Customer Service:</span>
									<span>(800)206-4005</span>
								</div>
							</div>
							<div className="employee-details-container-helpline-perx" style={{ marginLeft: "1.5rem" }}>
								<span style={{ fontSize: "0.9rem" }}>PERX</span>
								<span style={{ marginLeft: "0.5rem" }}>A Select Network</span>
							</div>
						</div>
						<div
							className="employee-details-container-helpline"
							style={{ marginTop: "0.1rem", marginLeft: "0" }}
						>
							This Card is for identification only; It does not guarantee benefit payment.
						</div>
					</Paper>
				</div>
			</div>
			<div className="employee-id-container" id="employee-id-container">
				<div className="paper-form-container">
					<Paper className="theme-border-radius emp-paper-container" elevation={1}>
						<Grid container className="summary-benefits-header-container" style={{ textAlign: "center" }}>
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								Summary of Benefits for Medical Plan
							</Grid>
						</Grid>
						<Grid container className="summary-benefits-plan-container" style={{ marginTop: "0.5rem" }}>
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<div className="summary-benefits-plan-items">
									<div className="summary-benefits-plan-item">
										<div className="summary-benefits-plan-item-label">Calendar Year Deductible</div>
										<div className="summary-benefits-plan-item-value">$750.00 Ind / $1,500 Fam</div>
									</div>
									<div className="summary-benefits-plan-item">
										<div className="summary-benefits-plan-item-label">
											Calendar Year Out-of-Pocket
										</div>
										<div className="summary-benefits-plan-item-value">$9,100 Ind / $18,200 Fam</div>
									</div>
								</div>
								<div style={{ marginTop: "0.2rem", marginBottom: "-0.1rem", paddingLeft: "2.35rem" }}>
									80% After deductible
								</div>
							</Grid>
						</Grid>
						<div className="summary-benefits-footer-container">
							<div className="footer-border" />
							<div
								className="footer-top-content-container"
								style={{ paddingTop: "0.2rem", fontSize: "0.6rem" }}
							>
								<span className="footer-top-sub-content" style={{ marginLeft: "4px" }}>
									Call Spectrum Review Services at (800) 258-5055
								</span>
							</div>
							<div
								className="footer-bottom-content"
								style={{ fontWeight: "900", fontSize: "0.5rem", marginBottom: "0.2;rem" }}
							>
								For any required precertification or prior plan approval of services. Failure to
								precertify will result in a benefit reduction.
							</div>

							<div className="footer-border" />

							<div className="footer-top-content-container" style={{ padding: "0.2rem" }}>
								<span
									className="footer-top-sub-content"
									style={{ marginLeft: "4px", fontSize: "0.65rem" }}
								>
									Healthsmart Provider : (800) 687 0500 or www.healthsmart.com
								</span>
							</div>

							<div className="footer-border" />
							<div className="footer-top-content-container" style={{ paddingTop: "0.3rem" }}>
								<span
									className="footer-top-sub-content"
									style={{ marginLeft: "4px", fontSize: "0.5rem" }}
								>
									Mental/Nervous & Substance Abuse services require precertification by INTERFACE EAP
									@ (800)324-4327
								</span>
							</div>
							<div
								className="footer-bottom-content"
								style={{ fontSize: "0.5rem", fontWeight: "900", marginBottom: "0.3rem" }}
							>
								Failure to precertify will result in a benefit reduction
							</div>
							<div className="footer-border" />
							<div
								className="footer-bottom-content"
								style={{
									textShadow: "0px 0.5px, 0.5px 0px, 0.1px 0.2px",
									fontSize: "0.7rem",
									marginBottom: 0,
									marginTop: "0.2rem"
								}}
							>
								For online claim access visit the Health Plan Portal
							</div>
							<div
								className="footer-bottom-content"
								style={{
									textShadow: "0px 0.5px, 0.5px 0px, 0.1px 0.2px",
									fontSize: "0.7rem",
									marginBottom: "0.3rem"
								}}
							>
								Webpage address is https://member.enrollment.nexcaliber.com
							</div>
							<div className="footer-border" />
							<div className="footer-bottom-content" style={{ marginTop: "0.2rem" }}>
								Mail all claims to: Nexcaliber , PO Box 802422, Dallas, Texas 75380
							</div>
							<div className="footer-logo-container">
								<img src={NexcalEmployeeLogo} alt="Nexcal employee Logo" />
							</div>
							<div className="footer-content" style={{ marginLeft: "-0.2rem" }}>
								Medical and Dental Benefit / Enrollment Questions and Verifications : Call Nexcaliber
								(800) 741-0185
							</div>
						</div>
					</Paper>
				</div>
			</div>
		</div>
	);
};

export default HealthCardActual;
